<template>
  <FieldContainer
    class="TextInput"
    v-bind="{ title, info, optional, error }"
    :data-testing-target="`Field: ${name}`"
  >
    <input v-bind="{ name, placeholder, value, disabled }" class="input">
  </FieldContainer>
</template>

<!--
NOTE that the <input> 'input' and 'change' events aren't handled here. Instead they
bubble up to Slide, which updates the fields based on the <input> name and value.
-->

<!--
NOTE this component is also used by the quiz module (QuizModule/slides/DetailsSlide.vue).
-->

<script>
import FieldContainer from './FieldContainer.vue'

export default {
  components: {
    FieldContainer,
  },
  props: {
    name: String,
    title: String,
    info: Object,
    placeholder: String,
    value: String,
    error: String,
    optional: Boolean,
    disabled: Boolean,
  },
}
</script>

<style scoped>
.input {
  padding: var(--spacing-2) var(--spacing-3);
  display: block;
  width: 100%;
  appearance: none;
  background: none;
  border-style: none;
}
.input:focus-visible {
  outline: none;
}
.input::placeholder {
  font-weight: 500;
  color: #8C8C8C;
}
</style>
